module.exports = __webpack_public_path__ + "fonts/Begum-Regular.64e6903.otf";